module.exports = __webpack_public_path__ + "media/applicants/bad_availability-3248625c.png";